<script setup lang="ts">
import SuccessFormIcon from 'assets/icons/success-form.svg'
import Button from '~/components/common/Button.vue'

defineEmits<{ close: [] }>()

withDefaults(
  defineProps<{
    message?: string
    withCloseButton?: boolean
  }>(),
  {
    withCloseButton: true,
    message:
      'Thank you for contacting us, our team will be in touch with you shortly.',
  },
)
</script>

<template>
  <div
    class="flex flex-col items-center h-full justify-center gap-y-10 max-w-96"
  >
    <div class="flex flex-col items-center gap-y-10">
      <SuccessFormIcon />
      <span class="font-semibold text-center">{{ message }}</span>
    </div>
    <div
      v-if="withCloseButton"
      class="flex flex-col items-center gap-y-2 w-full"
    >
      <Button class="!w-full" @click="$emit('close')">Close</Button>
    </div>
  </div>
</template>
